import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { ActionSheetService } from 'src/app/core/services/action-sheet.service';
import { DoktarConstantsService } from 'src/app/core/services/doktar-constants.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { UtilsService } from 'src/app/core/services/utils.service';
import { AddPheromoneLureComponent } from 'src/app/pages/pesttrapp/components/add-pheromone-lure/add-pheromone-lure.component';
import { AddStickyTrapComponent } from 'src/app/pages/pesttrapp/components/add-sticky-trap/add-sticky-trap.component';
import { DeviceFilizDetailResponse, DeviceTrapDetailResponse } from '../../models/profile';
import { ProfileService } from '../../services/profile.service';
import { PhotoCaptureTimeComponent } from '../photo-capture-time/photo-capture-time.component';
import { SensorSelectionComponent } from '../../../components/sensor-selection/sensor-selection.component';
import { ClientAlertService } from 'src/app/core/services/client-alert.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.scss'],
})
export class DeviceDetailComponent implements OnInit {
  deviceType: string;
  deviceId: number;
  querySubs: Subscription;
  filizData: DeviceFilizDetailResponse;
  trapData: DeviceTrapDetailResponse;
  databaseError: boolean = false;
  constructor(private profileService: ProfileService,
    private loadingService: LoadingService,
    private activatedRoute: ActivatedRoute,
    private actionSheetService: ActionSheetService,
    private doktarConstantService: DoktarConstantsService,
    private translateService: TranslateService,
    private modalService: ModalService,
    private utilsService: UtilsService,
    private alertService:ClientAlertService,
    private storageService:StorageService) { }

  ngOnInit() { }

  ionViewDidEnter() {
    this.querySubs = this.activatedRoute.queryParams.subscribe(e => {
      if (e["deviceType"]) {
        this.deviceType = e["deviceType"];
      }
      if (e["deviceId"]) {
        this.deviceId = +e["deviceId"];
      }
      setTimeout(() => {
        this.getDeviceDetail();
      }, 1);
    });
  }




  getDeviceDetail() {
    this.loadingService.showLoading();
    if (this.deviceType == "filiz" || this.deviceType == "filiz-pro" || this.deviceType == "filiz-mini")
      this.profileService.getDeviceFilizDetail(this.deviceId).subscribe(res => {
        this.loadingService.hideLoading();
        if (res.IsSuccess) {
          this.filizData = res.Data;
          
          this.databaseError = false;
        } else {
          this.databaseError = true;
        }
      }, err => {
        this.databaseError = true;
        this.loadingService.hideLoading();
      });
    if (this.deviceType == "trap")
      this.profileService.getDeviceTrapDetail(this.deviceId).subscribe(res => {
        this.loadingService.hideLoading();
        if (res.IsSuccess) {
          this.trapData = res.Data;
          this.databaseError = false;
        } else {
          this.databaseError = true;
        }
      }, err => {
        this.databaseError = true;
        this.loadingService.hideLoading();
      });
  }

  changePheromone(item) {
    this.modalService.presentModal({
      component: AddPheromoneLureComponent,
      componentProps: {
        deviceId: this.deviceId,
        insectType: {
          id: item?.InsectTypeId,
          value: item?.InsectTypeName
        }
      },
      options: ModalService.defaultOptionsTransparent
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(e => {
        if (e.role == "success") {
          this.getDeviceDetail();
        }
      });
    });
  }

  deviceAttChange(type: string = "") {
    if (type == "Network") {
      this.doktarConstantService.RequestNetworkList().subscribe(res => {
        let arr = res.map(e => {
          return {
            id: e.ConstantValue,
            value: e.AppendixA,
            role: e.ConstantValue
          }
        });
        this.actionSheetService.selectType(arr, this.translateService.instant("profile.network-priority")).then(e => {
          this.actionSheetService.generalActionSheet.onDidDismiss().then(res => {
            if (res.data)
              this.saveResValue("P", res.data, 0);
          });
        });
      });
    } else if (type == "Resolution") {
      this.doktarConstantService.RequestResolutionList().subscribe(res => {
        let arr = res.map(e => {
          return {
            id: e.ConstantValue,
            value: e.AppendixA,
            role: e.ConstantValue
          }
        });
        this.actionSheetService.selectType(arr, this.translateService.instant("profile.network-priority")).then(e => {
          this.actionSheetService.generalActionSheet.onDidDismiss().then(res => {
            if (res.data)
              this.saveResValue("R", res.data, 0);
          });
        });
      });

    } else if (type == "PhotoCapture") {
      this.modalService.presentModal({
        component: PhotoCaptureTimeComponent,
        componentProps: {
          timeArray: this.trapData.ImageFrequency
        },
        options: ModalService.defaultOptionsTransparent,
      }).then(e => {
        e.modalObj.onDidDismiss().then(res => {
          if (res.role == "update") {
            this.saveResValue("W", res.data, 0);
          }
        });
      });
    }
  }

  saveResValue(key: string, value: string, offset: number) {
    let payload = {
      DeviceId: this.deviceId,
      Key: key,
      Value: value,
      OffSet: offset
    }
    this.loadingService.showLoading();
    this.profileService.saveResponseValue(payload).subscribe(e => {
      this.loadingService.hideLoading();
      if (e.IsSuccess) {
        this.getDeviceDetail();
      }
    });
  }

  changeTrap() {
    let modalId = Date.now();
    this.modalService.presentModal({
      component: AddStickyTrapComponent,
      id: modalId,
      componentProps: {
        header: "sticky-trap.change-trap",
        deviceId: this.deviceId,
      },
      options: {
        cssClass: "center-modal-sticky"
      }
    }).then(modal => {
      modal.modalObj.onDidDismiss().then(e => {
        if (e.role == "success") {
          this.getDeviceDetail();
        }
      });
    });
  }
  changeSensorValue() {
    let modalId = Date.now();
    this.modalService.presentModal({
      id: modalId,
      component: SensorSelectionComponent,
      componentProps: {
        detailItem: this.filizData,
        page:'profile-detail',
        deviceType:this.deviceType
      },
      options: ModalService.defaultOptionsTransparent
    }).then(e => {
      this.modalService.modalOnDidDismiss(modalId).then(e => {
        if (e.role == "success") {
          if (this.deviceType == "trap") {
            this.storageService.lastTrapFarmId = null;
            this.storageService.set(StorageKeys.updated, true).then();

          } else {
            this.storageService.lastFilizFarmId = null;
            this.storageService.set(StorageKeys.updated, true).then();
          }
          this.getDeviceDetail();
          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
          }
          this.alertService.PopupAlert({
            buttons: [
              { callback: cancelCallback, color: "primary", fill: "clear", text: this.translateService.instant("general.ok") }
            ],
            title: this.translateService.instant("detail.sensor_notification_title"),
            description: this.translateService.instant("soil-sensor.sensor-notification-desc-" + e.data),
            icon: "checkmark-circle",
            role: 'success'
          }).then(response => { })
        } else if (e.role == "error") {
          let cancelCallback = (ev, modalId) => {
            this.modalService.dismissByModalId(modalId, {}, "buttonClicked")
          }
          this.alertService.PopupAlert({
            buttons: [
              { callback: cancelCallback, color: "primary", fill: "clear" }
            ],
            title: this.translateService.instant("detail.sensor_notification_err"),
            icon: "cloud-offline",
            role: 'danger'
          }).then(response => { })
        }
      })
    });
  }
}
